import { defineMessages } from 'react-intl';

export const giftCardRedemptionCtaMessages = defineMessages({
  label: {
    defaultMessage: 'Add to your account',
    description:
      'Gift Card Redemption Screen | "Add to your account" CTA label',
  },
});
